// extracted by mini-css-extract-plugin
export default {"modal":"SuggestedFriends--modal--HZD5k","modal-actions":"SuggestedFriends--modal-actions--NpK6m","modalActions":"SuggestedFriends--modal-actions--NpK6m"};